import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="error-boundary" className="flex min-h-screen flex-col items-center justify-center gap-4 bg-off p-8 text-center">
        <h1 className="t-h1">SOMETHING WENT WRONG.</h1>
        <p className="t-body max-w-md">{String(this.state.error?.message || this.state.error)}</p>
        <button type="button" data-testid="error-boundary-reload" onClick={() => window.location.assign("/home")} className="focus-ring rounded-full bg-navy px-6 py-3 font-display-bold uppercase tracking-[1.2px] text-white">
          Reload
        </button>
      </div>
    );
  }
}
